export default class ContactsService {}
